import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from 'static/locales/en/translation.json'
import de from 'static/locales/de/translation.json'
import frfr from 'static/locales/fr-fr/translation.json'
import frca from 'static/locales/fr-ca/translation.json'
import ptbr from 'static/locales/pt-br/translation.json'

const options = {
  order: ['querystring', 'navigator'],
  lookupQuerystring: 'lng',
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      'en-ca': {
        translation: en,
      },
      'en-us': {
        translation: en,
      },
      de: {
        translation: de,
      },
      'de-de': {
        translation: de,
      },
      'de-ch': {
        translation: de,
      },
      fr: {
        translation: frfr,
      },
      'fr-ch': {
        translation: frfr,
      },
      'fr-fr': {
        translation: frfr,
      },
      'fr-ca': {
        translation: frca,
      },
      'fr-be': {
        translation: frfr,
      },
      pt: {
        translation: ptbr,
      },
      'pt-br': {
        translation: ptbr,
      },
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: options,
    fallbackLng: 'en',
    debug: false,
    lowerCaseLng: true,
  })

export default i18n
